import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IBPaymentCardActionCaller extends Vue {

	callAction(
		action?: (...v: any[]) => void,
		args?: any[],
		throwable: boolean = false
	): any {
		if (!action || typeof action != 'function') return;

		try {
			return action(...(args || []));
		} catch (err) {
			console.warn(err);

			if (throwable) throw err;
		}
	}

}